import script from "./MyPage.vue?vue&type=script&setup=true&lang=js"
export * from "./MyPage.vue?vue&type=script&setup=true&lang=js"

import "./MyPage.vue?vue&type=style&index=0&id=120f009c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-120f009c"]])

export default __exports__